import { DynamicLabel } from "../../types";

export const defaultConfigForLabelling = `<View>
<RectangleLabels name="tag" toName="img">
  <Label background="#FF6347" value="PPE - Helmet" />
  <Label background="#FF6347" value="PPE - Vest" />
  <Label background="#FF6347" value="PPE - Helmet, Vest" />
  <Label background="#FF6347" value="PPE - Shoe" />
  <Label background="#FF6347" value="PPE - Gloves" />
  <Label background="#FF6347" value="PPE - Glass" />
  <Label background="#4c21e8" value="Behavioural Safety - Phone Usage" />
  <Label background="#e66465" value="Emergency Control - Person_Fallen" />
  <Label background="#e66465" value="Emergency Control - Smoke" />
  <Label background="#e66465" value="Hazardous Area - Lift_and_Hoist" />
  <Label background="#e66465" value="Hazardous Area - Work_at_the_edge" />
  <Label background="#e66465" value="Camera Health - Tampering" />
  <Label background="#e66465" value="Housekeeping - Clean_Vehicle_Road" />
  <Label background="#e66465" value="Housekeeping - Clean_Pedestrian_Way" />
  <Label background="#e66465" value="Housekeeping - Unattended_Object" />
</RectangleLabels>
<Image name="img" value="$image"/>
</View>
`;

export const getConfigForLabelling = (dynamicLabels: DynamicLabel[]) => {
  const labels = Array.isArray(dynamicLabels) && dynamicLabels?.map(({label, background}:DynamicLabel) => `<Label background="${background}" value="${label.replace(/"/g, "&quot;")}" />`)
  .join("\n");

// Update label config
const [beforeRectangleLabels, afterRectangleLabels] =
defaultConfigForLabelling.split("</RectangleLabels>");
return `${beforeRectangleLabels}${labels}</RectangleLabels>${afterRectangleLabels}`;
}

export const defaultConfig = `<View>
<RectangleLabels name="tag" toName="img">
</RectangleLabels>
<Image name="img" value="$image"/>
</View>
`;

export const getConfig = (dynamicLabels: DynamicLabel[]) => {
  const labels = dynamicLabels?.map(({label, background}:DynamicLabel) => `<Label background="${background}" value="${label.replace(/"/g, "&quot;")}" />`)
  .join("\n");

// Update label config
const [beforeRectangleLabels, afterRectangleLabels] =
  defaultConfig.split("</RectangleLabels>");
return `${beforeRectangleLabels}${labels}</RectangleLabels>${afterRectangleLabels}`;
}




export const extractLabelColors = (config: string): Map<string, string> => {
  const labelColors = new Map<string, string>();
  
  try {
    // Create a temporary DOM parser
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(config, "text/xml");
    
    // Find all Label elements
    const labelElements:any = xmlDoc.getElementsByTagName('Label');
    
    // Extract value and background color for each label
    for (const label of labelElements) {
      const value = label.getAttribute('value');
      const background = label.getAttribute('background');
      if (value && background) {
        labelColors.set(value, background);
      }
    }
  } catch (error) {
    console.error('Error parsing label config:', error);
  }
  
  return labelColors;
};


// Utility function to format labels with various sorting options
export const formatLabel = (
  mainCategory: DynamicLabel,
  subCategories: string[],
  options: {
    sort?: 'asc' | 'desc' | 'none';
    separator?: string;
    transform?: (s: string) => string;
  } = {}
) => {
  const {
    sort = 'asc',
    separator = ', ',
    transform = (s: string) => s
  } = options;

  // Sort subcategories based on option
  let sortedSubCategories = [...subCategories];
  if (sort === 'asc') {
    sortedSubCategories.sort((a, b) => a.localeCompare(b));
  } else if (sort === 'desc') {
    sortedSubCategories.sort((a, b) => b.localeCompare(a));
  }

  // Apply any transformation and join
  const subCategoriesString = sortedSubCategories
    .map(transform)
    .join(separator);

  return `${mainCategory.label} - ${subCategoriesString}`;
};